import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../../components/layout/AdminLayout";
import { Helmet } from "react-helmet-async";
import IntersessionList from "../../components/intersession/IntersessionSetupList";
import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";
import llacFav from "../../img/LLAC-favicon.ico";

const IntersessionListPage = () => {
  const navigate = useNavigate();
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const { getLeloRegistrations, LeloRegistrations, clearSearchFilterLelo } =
    adminRegistrationContext;

  useEffect(() => {
    getLeloRegistrations();
    return () => {
      clearSearchFilterLelo();
    };
  }, []);

  return (
    <AdminLayout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Secondary Enrollments</title>
        <link rel="icon" type="image/x-icon" href={llacFav} />
      </Helmet>
      <section id="interest-form-list-page">
        <div className="container">
          <h2
            className="text-center top-title"
            style={{ marginRight: "3.780px" }}
          >
            Secondary Enrollments Setup
          </h2>
          <IntersessionList items={LeloRegistrations} />
        </div>
      </section>
    </AdminLayout>
  );
};

export default IntersessionListPage;
